// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ResearchIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ResearchIcon" ref={forwardedRef} {...props}>
      <path d="m6.113 7.328 4.596-4.596a2.5 2.5 0 1 1 3.536 3.536l-1.157 1.157a5.36 5.36 0 0 1-.514 8.954h4.089v1.5h-14v-1.5h4.536a5.4 5.4 0 0 1-2.24-2.5H2.663v-1.5h7v1.5h-3a3.87 3.87 0 0 0 3.224 1.717 3.87 3.87 0 0 0 3.875-3.863c0-1.35-.696-2.54-1.751-3.231l-2.363 2.362zm2.121 0 1.414 1.415 3.536-3.536a1 1 0 0 0-1.414-1.414z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ResearchIcon = /* @__PURE__ */ Object.assign(
  ResearchIconComponent,
  { displayName: 'ResearchIcon' },
);
